// Entry point for the build script in your package.json
// import "@activeadmin/activeadmin" # rimosso per escludere has_many
import 'flowbite';
import Rails from '@rails/ujs';
import "@activeadmin/activeadmin/dist/active_admin/features/batch_actions"
import "@activeadmin/activeadmin/dist/active_admin/features/dark_mode_toggle"
import "@activeadmin/activeadmin/dist/active_admin/features/filters"
import "@activeadmin/activeadmin/dist/active_admin/features/main_menu"
import "@activeadmin/activeadmin/dist/active_admin/features/per_page"

Rails.start();

import "@fortawesome/fontawesome-free/js/all.min";

import './init'
import './override_has_many.js'
import './doready.js'
import 'select2/dist/js/i18n/it'; // non spostare in init https://www.youtube.com/watch?v=ql-Ng6OeI-M
import {initFlatpickr} from "./flatpickrOptions";
import {initFormTab} from "./custom/form_tab";

$(document).ready(function () {
    const sortFunction = data => data.sort((a, b) => {
        if (parseInt(a.id) === -1000) return 1;   // ordinamento per "ESCI"
        if (parseInt(b.id) === -1000) return -1;  // ordinamento per "ESCI"
        return a.text.localeCompare(b.text);
    });
    $('.select2').select2({theme: "classic", language: "it", width: '100%', allowClear: true, placeholder: ' ', sorter: sortFunction});
    $('.select2-filters').select2({theme: "classic", language: "it", width: '100%', sorter: sortFunction});
    $('.select2-tags').select2({theme: "classic", language: "it", tags: true, sorter: sortFunction});
    const setCurrentUDPSelect = $('.select2-set-udp');
    setCurrentUDPSelect.select2({theme: "classic", language: "it", width: '100%', placeholder: 'Seleziona UDP di lavoro', sorter: sortFunction, dropdownParent: $('#user-udp')});
    setCurrentUDPSelect.on('select2:select', function (e) {
        let data = e.params.data;
        $('#user-udp').addClass('hidden');
        window.location.href = $(data.element).data('url');
    });

    document.addEventListener('click', function (e) {
        const button = e.target.closest('[data-dropdown-toggle="user-udp"]');
        if (button) {
            // piccolo delay per assicurarsi che Tailwind abbia aperto la dropdown
            setTimeout(() => {
                $('#set_udp').select2('open');
            }, 50);
        }
    });

    initFlatpickr()

    const $form = $('form.journal_entry ')
    const $select = $form.find('.select2-counterpart');
    const $selectLabel = $select.data("create-label")

    $select.select2({
        theme: "classic", width: '100%',
        sorter: sortFunction,
        allowClear: true, placeholder: ' ',
        language: {
            noResults: function () {
                return "<a class='click-create-counterpart' href='javascript: void(0);'>" + $selectLabel + "</a>";
            }
        },
        escapeMarkup: function (markup) {
            return markup;
        }

    });

    $('[id^="dialog-jes-"]').each(function () {
        const modalEl = this;

        const options = {
            onShow: () => {
                // set the tooltip content element

                $.each($(modalEl).find('[data-tooltip-target^="tooltip-copy-"]'), function (el) {
                    const id = $(this).attr('data-tooltip-target')
                    const id2 = $(this).attr('data-copy-to-clipboard-target')

                    const $defaultTooltipMessage = $(modalEl).find('#default-tooltip-message');
                    const $successTooltipMessage = $(modalEl).find('#success-tooltip-message');

                    const o = {
                        placement: 'top',
                        triggerType: 'hover',
                    }
                    const o2 = {
                        contentType: 'textContent',
                        onCopy: () => {
                            $defaultTooltipMessage.addClass('hidden');
                            $successTooltipMessage.removeClass('hidden');

                            setTimeout(() => {
                                $defaultTooltipMessage.removeClass('hidden');
                                $successTooltipMessage.addClass('hidden');
                            }, 2000);
                        }
                    }
                    const io = {
                        id: id,
                        override: true
                    };

                    const io2 = {
                        id: id2,
                        override: true
                    };

                    const $triggerEl = this;
                    const $targetEl = $(`#${id}`)[0]
                    const $targetEl2 = $(`#${id2}`)[0]
                    new Tooltip($targetEl, $triggerEl, o, io);
                    new CopyClipboard($triggerEl, $targetEl2, o2, io2);
                });
            },
        };

        const instanceOptions = {
            id: $(this).attr('id'),
            override: true
        };

        const modal = new Modal(modalEl, options, instanceOptions);

        $(`[data-modal-target="${$(this).attr('id')}"]`).on('click', function () {
            modal.show();
        });

        $(modalEl).find('[data-modal-hide]').on('click', () => {
            modal.hide();
        });
    });

    $('[id^="dialog-sez-"]').each(function () {
        const modalEl = this;
        const options = {
            placement: 'bottom-right',
            backdrop: 'dynamic',
            backdropClasses:
                'bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40',
            closable: true,
            onHide: () => {
                $(modalEl).find('.select-all-sez').off('click')
            },
            onShow: () => {
                const s = $(this).find('.select2-tags')
                s.select2({
                    dropdownParent: $(modalEl),
                    sorter: sortFunction,
                    maximumSelectionLength: s.data('maximumselectionlength'),
                    width: '100%',
                    theme: "classic", language: "it", tags: true
                });

                s.on('select2:unselect', function (e) {
                    // altrimenti la dropdown rimana aperta
                    setTimeout(() => {
                        $(this).select2('close');
                    }, 0);
                });

                $(modalEl).find('.select-all-sez').on('click', function () {
                    s.find("option").remove();
                    $(this).data('ids').forEach(function (tag) {
                        let newOption = new Option(tag, tag, true, true); // testo, valore, defaultSelected, selected
                        s.append(newOption)
                    });

                    s.trigger('change')
                })

                s.on('change', function (e) {
                    // const selectedData = e.params.data;

                    $.ajax({
                        url: $(this).data('preview-url'),
                        data: {journal_ids: $(this).val()},
                        success: function (data) {
                            $(modalEl).find('.detail-container-sezionale').html(data)
                        }
                    });
                })
            },
            // onToggle: () => {
            //     console.log('modal has been toggled');
            // },
        };

// instance options object
        const instanceOptions = {
            id: $(this).attr('id'),
            override: true
        };

        const modal = new Modal(modalEl, options, instanceOptions);

        $(`[data-modal-target="${$(this).attr('id')}"]`).on('click', function () {
            modal.show();
        });

        $(modalEl).find('[data-modal-hide]').on('click', () => {
            modal.hide();
        });
    });

    initFormTab() // VA PER ULTIMO PER ESSERE SICURO DI AVER INIZIALIZZATO tutti i campi

});

function toggleSidebar() {
    const sidebar = document.getElementById("main-menu");
    const content = document.getElementById("main-content");

    sidebar.classList.toggle("collapsed");
    content.classList.toggle("collapsed");

    const collapsed = sidebar.classList.contains("collapsed") ? "true" : "false";
    console.log(collapsed)
    document.cookie = `sidebar-collapsed=${collapsed}; path=/; max-age=31536000`;
}

window.toggleSidebar = toggleSidebar;